import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Mail, Smartphone, ListChecks, Settings as SettingsIcon, Shield, Building2, History, Activity, FileArchive, Newspaper } from "lucide-react";
import TemplatesTab from "./TemplatesTab";
import SmsTemplatesTab from "./SmsTemplatesTab";
import JobPreferencesTab from "./JobPreferencesTab";
import SettingsTab from "./SettingsTab";
import AdminsTab from "./AdminsTab";
import AgenciesTab from "./AgenciesTab";
import EmailLogsTab from "./EmailLogsTab";
import AuditTab from "./AuditTab";
import BulkImportTab from "./BulkImportTab";
import NewsTab from "./NewsTab";

const SUBTAB_CLS = "rounded-none data-[state=active]:bg-[#F0E9F3] data-[state=active]:text-[#662483] data-[state=active]:border-b-2 data-[state=active]:border-[#662483] gap-2 text-xs font-semibold";

export default function ConfigurationTab() {
  return (
    <div data-testid="configuration-tab" className="space-y-4">
      <Tabs defaultValue="settings" className="space-y-4" orientation="vertical">
        <div className="flex flex-col lg:flex-row gap-4">
          {/* Vertical sidebar of sub-tabs */}
          <TabsList className="bg-white border border-gray-200 rounded-none p-1 gap-1 flex lg:flex-col h-auto flex-wrap lg:w-56 lg:shrink-0 justify-start">
            <p className="text-[10px] uppercase tracking-wider text-gray-400 px-2 pt-2 pb-1 hidden lg:block w-full">Paramétrage</p>
            <TabsTrigger value="settings" className={SUBTAB_CLS + " lg:w-full lg:justify-start"} data-testid="subtab-settings">
              <SettingsIcon className="w-3.5 h-3.5" /> Paramètres système
            </TabsTrigger>
            <TabsTrigger value="email-templates" className={SUBTAB_CLS + " lg:w-full lg:justify-start"} data-testid="subtab-email-templates">
              <Mail className="w-3.5 h-3.5" /> Templates Email
            </TabsTrigger>
            <TabsTrigger value="sms-templates" className={SUBTAB_CLS + " lg:w-full lg:justify-start"} data-testid="subtab-sms-templates">
              <Smartphone className="w-3.5 h-3.5" /> Templates SMS
            </TabsTrigger>
            <TabsTrigger value="job-prefs" className={SUBTAB_CLS + " lg:w-full lg:justify-start"} data-testid="subtab-job-prefs">
              <ListChecks className="w-3.5 h-3.5" /> Préférences métier
            </TabsTrigger>

            <p className="text-[10px] uppercase tracking-wider text-gray-400 px-2 pt-3 pb-1 hidden lg:block w-full border-t border-gray-100 mt-2">Administration</p>
            <TabsTrigger value="admins" className={SUBTAB_CLS + " lg:w-full lg:justify-start"} data-testid="subtab-admins">
              <Shield className="w-3.5 h-3.5" /> Administrateurs
            </TabsTrigger>
            <TabsTrigger value="agencies" className={SUBTAB_CLS + " lg:w-full lg:justify-start"} data-testid="subtab-agencies">
              <Building2 className="w-3.5 h-3.5" /> Agences
            </TabsTrigger>
            <TabsTrigger value="email-logs" className={SUBTAB_CLS + " lg:w-full lg:justify-start"} data-testid="subtab-email-logs">
              <History className="w-3.5 h-3.5" /> Logs Emails
            </TabsTrigger>
            <TabsTrigger value="audit" className={SUBTAB_CLS + " lg:w-full lg:justify-start"} data-testid="subtab-audit">
              <Activity className="w-3.5 h-3.5" /> Audit
            </TabsTrigger>
            <TabsTrigger value="bulk-import" className={SUBTAB_CLS + " lg:w-full lg:justify-start"} data-testid="subtab-bulk-import">
              <FileArchive className="w-3.5 h-3.5" /> Import massif
            </TabsTrigger>
            <TabsTrigger value="news" className={SUBTAB_CLS + " lg:w-full lg:justify-start"} data-testid="subtab-news">
              <Newspaper className="w-3.5 h-3.5" /> Actualités
            </TabsTrigger>
          </TabsList>

          {/* Content area */}
          <div className="flex-1 min-w-0">
            <TabsContent value="settings" className="m-0"><SettingsTab /></TabsContent>
            <TabsContent value="email-templates" className="m-0"><TemplatesTab /></TabsContent>
            <TabsContent value="sms-templates" className="m-0"><SmsTemplatesTab /></TabsContent>
            <TabsContent value="job-prefs" className="m-0"><JobPreferencesTab /></TabsContent>
            <TabsContent value="admins" className="m-0"><AdminsTab /></TabsContent>
            <TabsContent value="agencies" className="m-0"><AgenciesTab /></TabsContent>
            <TabsContent value="email-logs" className="m-0"><EmailLogsTab /></TabsContent>
            <TabsContent value="audit" className="m-0"><AuditTab /></TabsContent>
            <TabsContent value="bulk-import" className="m-0"><BulkImportTab /></TabsContent>
            <TabsContent value="news" className="m-0"><NewsTab /></TabsContent>
          </div>
        </div>
      </Tabs>
    </div>
  );
}
